import { useNavigate } from "react-router-dom";
import ImageButton from "./image-button";

interface CloseButtonProps {
  icon?: string;
  onClick?: (e: React.MouseEvent) => void;
  goBack?: boolean;
  withGlassBg?: boolean;
  size?: number;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  icon = "/assets/icon_close.png",
  onClick,
  goBack = true,
  withGlassBg = false,
  size = 24
}) => {
  let navigate = useNavigate();
  return (
    <ImageButton
      className={withGlassBg ? "button-glass" : ""}
      onClick={(e) => {
        if (onClick) onClick(e);
        if (goBack) navigate(-1);
      }}
      src={icon}
      alt="close button"
      size={size}
    />
  );
};

export default CloseButton;
